import { useState, useEffect } from "react";

const TWENTY_FOUR_HOURS_IN_SECONDS = 24 * 60 * 60;

const calculateRemainingSeconds = (endDate) => {
  if (!endDate) {
    return 0;
  }
  const now = Date.now();
  const end = new Date(endDate).getTime();

  if (Number.isNaN(end)) {
    return 0;
  }

  return Math.max(0, Math.floor((end - now) / 1000));
};

const useCountdown = (endDate) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    calculateRemainingSeconds(endDate),
  );

  const showCountdown =
    remainingSeconds > 0 && remainingSeconds <= TWENTY_FOUR_HOURS_IN_SECONDS;

  useEffect(() => {
    if (!showCountdown) {
      return;
    }

    const intervalId = setInterval(() => {
      setRemainingSeconds((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(intervalId);

          return 0;
        }

        return next;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [showCountdown]);

  return { remainingSeconds, showCountdown };
};

export default useCountdown;
